import { render, staticRenderFns } from "./EntityZone.vue?vue&type=template&id=0a7472ac&scoped=true&"
import script from "./EntityZone.vue?vue&type=script&lang=js&"
export * from "./EntityZone.vue?vue&type=script&lang=js&"
import style0 from "./EntityZone.vue?vue&type=style&index=0&id=0a7472ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7472ac",
  null
  
)

export default component.exports